const HisMapPin = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg style={_sx} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 0.916016C13.1879 0.916145 15.2869 1.78595 16.834 3.33301C18.3808 4.88002 19.2498 6.97832 19.25 9.16602C19.25 12.2778 17.2069 15.2516 15.3525 17.3379C14.404 18.405 13.4577 19.2919 12.75 19.9111C12.3958 20.2211 12.0989 20.4656 11.8896 20.6338C11.7852 20.7177 11.7022 20.7834 11.6445 20.8281C11.6159 20.8503 11.5929 20.8679 11.5771 20.8799C11.5696 20.8856 11.563 20.8902 11.5586 20.8936C11.5566 20.8951 11.5541 20.8965 11.5527 20.8975L11.5508 20.8994C11.2657 21.1132 10.8866 21.1397 10.5781 20.9795L10.4502 20.8994L10.4473 20.8975C10.446 20.8965 10.4443 20.895 10.4424 20.8936C10.438 20.8903 10.4315 20.8857 10.4238 20.8799C10.4081 20.8679 10.3851 20.8504 10.3564 20.8281C10.2988 20.7834 10.2158 20.7178 10.1113 20.6338C9.90211 20.4657 9.60533 20.2212 9.25098 19.9111C8.5433 19.2919 7.59715 18.4052 6.64844 17.3379C4.79397 15.2516 2.74902 12.2781 2.74902 9.16602C2.74917 6.97819 3.61995 4.88005 5.16699 3.33301C6.71406 1.78614 8.81225 0.916102 11 0.916016Z"
        fill={strokeColor}
      />
      <path
        d="M11 5.72949C12.8985 5.72949 14.4375 7.26851 14.4375 9.16699C14.4374 11.0654 12.8984 12.6045 11 12.6045C9.1016 12.6045 7.56263 11.0654 7.5625 9.16699C7.5625 7.26851 9.10152 5.72949 11 5.72949Z"
        fill="white"
      />
    </svg>
  );
};

export default HisMapPin;
